export default __webpack_public_path__ + "static/media/helly.8c553738.jpg";